const NewsHero = () => {
  return (
    <section className="relative py-20 md:py-32 overflow-hidden bg-background">
      {/* Decorative gradient borders */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 max-w-4xl text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Latest News & Insights
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
          Stay updated on AI innovations, industry trends, and company updates
        </p>
      </div>
    </section>
  );
};

export default NewsHero;